// extracted by mini-css-extract-plugin
export default {"container":"CodeChallenge_container__FDyGq"};